import * as React from "react";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import TableCell from "@mui/material/TableCell";

import DeleteOutlineOutlined from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlined from "@mui/icons-material/EditOutlined";
import RemoveRedEyeOutlined from "@mui/icons-material/RemoveRedEyeOutlined";

import { useDispatch, useSelector } from "react-redux";
import {
  editCategory,
  openDeleteModal,
  viewCategory,
} from "../../../feature/category/categorySlice";
import CategoryModals from "./CategoryModals";

export default function CategoryTableRow(props) {
  const { mode } = useSelector((state) => state.mode);
  const dispatch = useDispatch();
  console.log("cate", props);
  return (
    <>
      {props?.row?.map((row) => (
        <TableRow key={row.id}>
          <TableCell component='th' scope='row'>
            {row.id}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.category_name}
          </TableCell>
          {/* <TableCell>{row.email}</TableCell> */}
          <TableCell>
            <Tooltip title='Edit'>
              <IconButton
                aria-label='edit'
                sx={{
                  "&:hover": {
                    color: "#3366ff",
                  },
                  color: mode === "light" ? "#222b45" : "#ffffff",
                }}
                onClick={() => dispatch(editCategory(row))}
              >
                <EditOutlined />
              </IconButton>
            </Tooltip>
            <Tooltip title='View'>
              <IconButton
                aria-label='view'
                sx={{
                  "&:hover": {
                    color: "#3366ff",
                  },
                  color: mode === "light" ? "#222b45" : "#ffffff",
                }}
                onClick={() => dispatch(viewCategory(row))}
              >
                <RemoveRedEyeOutlined />
              </IconButton>
            </Tooltip>
            <Tooltip title='Delete'>
              <IconButton
                aria-label='delete'
                sx={{
                  "&:hover": {
                    color: "#F24C4C",
                  },
                  color: mode === "light" ? "#222b45" : "#ffffff",
                }}
                onClick={() => dispatch(openDeleteModal(row))}
              >
                <DeleteOutlineOutlined />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      ))}

      <CategoryModals />
    </>
  );
}
